import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = Pa·s (dynamic viscosity). */
export const DYNAMIC_VISCOSITY_PIVOT: Record<string, number> = {
  'pa*s': 1,
  cp: 0.001,
};

export const transformDynamicViscosity = createPivotTransformer(DYNAMIC_VISCOSITY_PIVOT);

/** Centistokes — kinematic; no cross-family conversion with dynamic units. */
export const KINEMATIC_VISCOSITY_PIVOT: Record<string, number> = {
  cst: 1,
};

export const transformKinematicViscosity = createPivotTransformer(KINEMATIC_VISCOSITY_PIVOT);
